import { render, staticRenderFns } from "./Enchants.vue?vue&type=template&id=d4134846&"
import script from "./Enchants.vue?vue&type=script&lang=js&"
export * from "./Enchants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports